<template>
  <div id="app">
    <header>
      <title>Luis For</title>
    </header>
    <body>
      <Home/>
    </body>
  </div>
</template>

<script>
import Home from './pages/Home.vue';


export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>

</style>
